import { Action, createReducer, on } from '@ngrx/store';
import { AppointmentResourceSettingsActions } from './appointment-resource-settings.actions';
import { AppointmentResource } from './appointment-resource-settings.model';

export const STORE_FEATURE_KEY_RESOURCES = 'appointmentResource';

export class AppointmentResourceSettingsState {
    loadingIndicator: boolean;
    appointmentResources: Array<AppointmentResource>;
    revertChanges: boolean;
    hasResources: boolean; // flag for disabling tab
}

export const initializeAppointmentResourceSettingsState: AppointmentResourceSettingsState = {
    appointmentResources: [],
    loadingIndicator: false,
    revertChanges: false,
    hasResources: false
};

const reducer = createReducer(
    initializeAppointmentResourceSettingsState,
    on(AppointmentResourceSettingsActions.getAppointmentResourcesSuccess, (state, { payload }) =>
        ({ ...state,
           appointmentResources: payload.appointmentResources,
           loadingIndicator: true,
           revertChanges: false,
           hasResources: payload.appointmentResources.length > 0
        })),
    on(AppointmentResourceSettingsActions.openConfirmDialogCancel, (state,  payload) =>
        ({ ...state,
           loadingIndicator: true,
           revertChanges: true
        })),
    on(AppointmentResourceSettingsActions.saveResourcesStrategyMapping, (state, payload) =>
        ({ ...state,
           loadingIndicator: false,
           revertChanges: false
        }))
);

export function AppointmentResourceSettingsReducer(state: AppointmentResourceSettingsState | undefined, action: Action) {
    return reducer(state, action);
}
